import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService } from 'core-lib';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  constructor(private backendSvc: BackendService) { }


  public requestReset(userName: string, email: string): Observable<any> {

    let data = { userName, email };

    return this.backendSvc.post(environment.requestPasswordResetUrl, data)
      .pipe(map((n: RequestPasswordResetResponse) => {
        return n.data;
      }));
  }

  public validateResetPassword(activationCode: string, username: string): Observable<ValidatePasswordResetResponseData> {

    let url = environment.validatePasswordResetUrl + '/' + activationCode + '?username=' + username;

    return this.backendSvc.get(url)
      .pipe(map((n: ValidatePasswordResetResponse) => {
        return n.data;
      }));

  }

  public resetPassword(activationCode: string, username: string, password: string): Observable<boolean> {
    let data = { username: username, password: password };
    let url = environment.confirmPasswordResetUrl + '/' + activationCode;
    return this.backendSvc.put(url, data)
      .pipe(map((n: ConfirmPasswordResetResponse) => {
        return true;
      }));
  }

}

export class RequestPasswordResetResponse {
  public code: number;
  public message: string;
  public data: { isSuccess: boolean, errorMessage: string};
}

export class ValidatePasswordResetResponse {
  public code: number;
  public message: string;
  public data: ValidatePasswordResetResponseData;
}

export class ValidatePasswordResetResponseData {
  public exists: boolean;
}

export class ConfirmPasswordResetResponse {
  public code: number;
  public message: string;
}